export default __webpack_public_path__ + "static/media/pic5.48ae2e5c.jpg";